export const getSum = (value1, value2) => {
  let sum = Number(value1) + Number(value2)
  return new Intl.NumberFormat("de-DE",{currency:'EUR'}).format( (sum/100))
};
